/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// api
import { apiClient } from '@lib/api-client';
import { useMutation } from '@tanstack/react-query';

// mantine
import { notifications } from '@mantine/notifications';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { TCertificate } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                    Types                                   */
/* -------------------------------------------------------------------------- */
type TBodyApi = {
	offset: string;
	language: string;
};

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const createCertificate = (
	body: TBodyApi
): Promise<TCertificate> => {
	return apiClient.post('/certificates', body);
};

export const useCreateCertificate = () => {
	const { t } = useTranslation();
	const {
		mutate,
		isPending: isLoading,
		isSuccess,
		data,
	} = useMutation({
		mutationFn: createCertificate,
		onError: (error: any) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'var(--mantine-color-igluRed-9)',
			});
		},
	});

	return { mutate, isLoading, isSuccess, data };
};
